export default "__VITE_ASSET__DVA0my1J__"